(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
(function () {
  // Keep a constant scroll speed regardless of how many messages there are:
  // set the animation duration from the track width so pixels/second stays even.
  function setup(track) {
    var speed = parseFloat(track.getAttribute('data-speed')) || 30;
    var pxPerSec = 2000 / speed; // lower slider value = faster
    function apply() {
      var groupWidth = track.scrollWidth / 2; // track holds two identical groups
      if (groupWidth > 0) track.style.animationDuration = (groupWidth / pxPerSec) + 's';
    }
    apply();
    window.addEventListener('load', apply);
    window.addEventListener('resize', apply, { passive: true });
  }
  document.querySelectorAll('.announcement-bar__track').forEach(setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    // Bound once per page load. Every listener is delegated off `document`, so
    // the handlers survive the section being swapped out after each update.
    if (window.__ruckOnCartBound) return;
    window.__ruckOnCartBound = true;

    var DEBOUNCE_MS = 450;

    // Edits are accumulated into one batch and the resulting requests are run
    // strictly one at a time. Firing a request per edit would let a re-render
    // land on top of a quantity the shopper had already typed but that hadn't
    // been sent yet, silently dropping it.
    var pending = null;
    var timer = null;
    var queue = [];
    var inflight = false;

    function root() {
      return document.querySelector('.cart-page');
    }

    function route(name, fallback) {
      var el = root();
      var url = el && el.getAttribute(name);
      return url && url.length ? url : fallback;
    }

    function qtyInput(key) {
      var el = root();
      if (!el || !key) return null;
      var escaped = key.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      return el.querySelector('.cart-item__qty-input[data-key="' + escaped + '"]');
    }

    function isDirty() {
      return pending !== null || timer !== null || queue.length > 0 || inflight;
    }

    // Accelerated checkout buttons (Shop Pay, PayPal, Apple Pay) hand the
    // server-side cart straight to checkout — they never carry this form's
    // updates. Keep them inert until every edit has actually been written, or
    // they check out at the old quantity. The regular checkout button is safe:
    // it POSTs updates[key] with the form.
    function syncBusy() {
      var el = root();
      if (!el) return;
      var busy = isDirty();
      el.classList.toggle('cart-page--busy', busy);
      Array.prototype.forEach.call(
        el.querySelectorAll('.cart-summary__alt-checkout'),
        function (node) {
          node.classList.toggle('cart-summary__alt-checkout--locked', busy);
          node.setAttribute('aria-busy', busy ? 'true' : 'false');
        }
      );
    }

    function setStatus(text, isError) {
      var status = document.getElementById('cart-community-status');
      if (!status) return;
      status.textContent = text;
      status.classList.toggle('cart-community__status--error', !!isError);
    }

    function updateHeaderCount(count) {
      var badge = document.querySelector('.cart-icon__count');
      if (badge) {
        badge.textContent = count;
        badge.classList.toggle('is-hidden', count === 0);
      }
      var mobile = document.querySelector('.mobile-nav__cart-count');
      if (mobile) mobile.textContent = count;
      var link = document.querySelector('.site-header__cart-icon');
      if (link) link.setAttribute('aria-label', 'Cart, ' + count + ' items');
    }

    function render(html) {
      var current = root();
      if (!current || !html) return;

      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-page');
      if (!fresh) return;

      // Carry over what the shopper has typed but not yet submitted.
      var noteEl = document.getElementById('cart-note');
      var note = noteEl ? noteEl.value : null;
      var active = document.activeElement;
      var focusKey =
        active && active.classList && active.classList.contains('cart-item__qty-input')
          ? active.dataset.key
          : null;

      current.replaceWith(fresh);

      if (note !== null) {
        var freshNote = document.getElementById('cart-note');
        if (freshNote) freshNote.value = note;
      }
      if (focusKey) {
        var input = qtyInput(focusKey);
        if (input) {
          input.focus();
          var caret = input.value.length;
          try { input.setSelectionRange(caret, caret); } catch (err) {}
        }
      }
    }

    function send(job) {
      var el = root();
      if (!el) {
        inflight = false;
        return;
      }

      var sectionId = el.getAttribute('data-section-id');
      var payload = job.payload;
      payload.sections = sectionId;
      payload.sections_url = window.location.pathname;

      fetch(job.url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart update failed');
          return res.json();
        })
        .then(function (cart) {
          updateHeaderCount(cart.item_count);
          // Only repaint once nothing is left to write. Repainting over a
          // still-unsent edit would replace it with the stale server value.
          var more = pending !== null || timer !== null || queue.length > 0;
          if (!more && cart.sections && cart.sections[sectionId]) {
            render(cart.sections[sectionId]);
          }
          if (job.done) job.done(cart);
        })
        .catch(function () {
          // The server cart is the source of truth. Without a handler of its
          // own, reload rather than leave a quantity on screen that was never
          // written to the cart.
          if (job.fail) job.fail();
          else window.location.reload();
        })
        .then(function () {
          inflight = false;
          drain();
        });
    }

    function drain() {
      if (inflight || queue.length === 0) {
        syncBusy();
        return;
      }
      inflight = true;
      syncBusy();
      send(queue.shift());
    }

    function enqueue(url, payload, done, fail) {
      queue.push({ url: url, payload: payload, done: done, fail: fail });
      drain();
    }

    // Send everything accumulated so far as a single /cart/update call.
    function flush() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      if (pending === null) {
        syncBusy();
        return;
      }
      var batch = pending;
      pending = null;
      enqueue(route('data-cart-update-url', '/cart/update'), { updates: batch });
    }

    function stage(key, quantity) {
      if (!key) return;
      if (pending === null) pending = {};
      pending[key] = quantity;
      if (timer) clearTimeout(timer);
      timer = setTimeout(flush, DEBOUNCE_MS);
      syncBusy();
    }

    function readQuantity(input) {
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) return null;
      return qty;
    }

    // Quantity steppers — adjust the input, then persist it.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.cart-item__qty-btn') : null;
      if (!btn) return;

      var wrapper = btn.closest('.cart-item__qty');
      var input = wrapper && wrapper.querySelector('.cart-item__qty-input');
      if (!input) return;

      var current = parseInt(input.value, 10);
      if (isNaN(current) || current < 0) current = 0;

      if (btn.dataset.action === 'increase') {
        input.value = current + 1;
      } else if (btn.dataset.action === 'decrease') {
        input.value = Math.max(0, current - 1);
      }

      stage(input.dataset.key, parseInt(input.value, 10));
    });

    // Typed quantities. A half-typed or cleared field is left alone until the
    // field is committed.
    document.addEventListener('input', function (e) {
      var input = e.target;
      if (!input.classList || !input.classList.contains('cart-item__qty-input')) return;
      var qty = readQuantity(input);
      if (qty === null) return;
      stage(input.dataset.key, qty);
    });

    document.addEventListener('change', function (e) {
      var target = e.target;

      // Commit a typed quantity as soon as the field is committed or blurred.
      if (target.classList && target.classList.contains('cart-item__qty-input')) {
        var qty = readQuantity(target);
        if (qty === null) {
          target.value = target.defaultValue;
          return;
        }
        stage(target.dataset.key, qty);
        flush();
        return;
      }

      // Community selector — store the choice as a line item property.
      // /cart/change.js assumes a quantity of 1 when one isn't sent, so the
      // line's current quantity has to travel with the properties or the line
      // is quietly knocked back down to a single unit.
      if (target.id !== 'cart-community-select') return;

      var itemKey = target.dataset.itemKey;
      var input = qtyInput(itemKey);
      var quantity = input ? readQuantity(input) : null;
      if (quantity === null || quantity < 1) {
        quantity = parseInt(target.dataset.itemQuantity, 10) || 1;
      }

      setStatus('Saving…', false);

      // Flush first: a properties change rewrites the line item key, so any
      // quantity edit still holding the old key has to land before it.
      flush();

      // The section is re-rendered afterwards to pick up the new key.
      enqueue(
        route('data-cart-change-url', '/cart/change'),
        {
          id: itemKey,
          quantity: quantity,
          properties: { Community: target.value }
        },
        function () {
          setStatus('Saved', false);
          setTimeout(function () { setStatus('', false); }, 2000);
        },
        function () {
          setStatus('Error — try again', true);
        }
      );
    });

    // Anything still queued when the shopper leaves the page would be lost, so
    // get it on the wire immediately.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flush();
    });

    // The plain checkout button POSTs updates[key] itself, so its own edits are
    // safe; flushing keeps the cart consistent for every other exit route.
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.id === 'cart-form') flush();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    var sortSelect = document.querySelector('[data-sort-select]');
    if (!sortSelect) return;

    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var wrapper = document.getElementById('site-header-wrapper');

  // Our own fixed wrapper around the header group (see layout/theme.liquid).
  var group = document.getElementById('site-header-fixed');

  // Size the in-flow spacer to match the fixed header's exact height.
  var spacer = document.getElementById('header-spacer');
  function sizeSpacer() {
    if (spacer && group) spacer.style.height = group.offsetHeight + 'px';
  }
  sizeSpacer();
  window.addEventListener('load', sizeSpacer);
  window.addEventListener('resize', sizeSpacer, { passive: true });

  // Scroll-shadow + hide-on-scroll-down / reveal-on-scroll-up
  var announcementBar = document.querySelector('.announcement-bar');
  var abHeight = announcementBar ? announcementBar.offsetHeight : 42;
  var lastY = window.scrollY;
  var ticking = false;

  function onScroll() {
    var y = window.scrollY;

    // Solid backdrop once past the announcement bar
    if (wrapper) wrapper.classList.toggle('is-scrolled', y > abHeight);

    if (group) {
      // Reveal on ANY upward movement, anywhere on the page.
      if (y < lastY) {
        group.classList.remove('header-group--hidden');
      // Hide only when scrolling down past the announcement bar.
      } else if (y > lastY && y > abHeight + 80) {
        group.classList.add('header-group--hidden');
      }

      // Always show at the very top.
      if (y <= abHeight) group.classList.remove('header-group--hidden');
    }

    lastY = y;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });

  // Mobile nav
  var nav      = document.getElementById('mobile-nav');
  var toggle   = document.getElementById('mobile-nav-toggle');
  var close    = document.getElementById('mobile-nav-close');
  var backdrop = document.getElementById('mobile-nav-backdrop');
  if (!nav || !toggle) return;

  function openNav() {
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.documentElement.setAttribute('scroll-lock', '');
    // Focus the close button for accessibility
    if (close) setTimeout(function () { close.focus(); }, 50);
  }

  function closeNav() {
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.removeAttribute('scroll-lock');
    toggle.focus();
  }

  toggle.addEventListener('click', openNav);
  if (close)    close.addEventListener('click', closeNav);
  if (backdrop) backdrop.addEventListener('click', closeNav);

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) closeNav();
  });

  // Close when a nav link is tapped
  nav.querySelectorAll('.mobile-nav__link, .mobile-nav__sublink, .mobile-nav__cart, .mobile-nav__logo').forEach(function (el) {
    el.addEventListener('click', closeNav);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHero(hero) {
    var slides = hero.querySelectorAll('.hero__slide');
    if (slides.length < 2) return; // nothing to rotate

    var dots  = hero.querySelectorAll('.hero__dot');
    var speed = (parseInt(hero.getAttribute('data-autoplay'), 10) || 6) * 1000;
    var index = 0;
    var timer = null;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
    }

    function next() { show(index + 1); }

    function start() {
      if (speed > 0) {
        stop();
        timer = setInterval(next, speed);
      }
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-dot'), 10));
        start(); // restart the clock after a manual pick
      });
    });

    // Pause when the hero is off-screen to save cycles
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.1 }).observe(hero);
    } else {
      start();
    }
  }

  document.querySelectorAll('[data-hero]').forEach(initHero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function () {
    var toggle = document.querySelector('.pw-access__toggle');
    var form   = document.getElementById('pw-access-form');
    if (!toggle || !form) return;

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      if (expanded) {
        form.hidden = true;
      } else {
        form.hidden = false;
        form.querySelector('input[type="password"]').focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    var form = document.getElementById('product-form');
    if (!form) return;

    var pageData = {};
    var pageDataEl = document.getElementById('product-page-data');
    if (pageDataEl) {
      try { pageData = JSON.parse(pageDataEl.textContent); } catch (e) {}
    }

    var variantsData = [];
    var variantsEl = document.getElementById('product-variants-json');
    if (variantsEl) {
      try { variantsData = JSON.parse(variantsEl.textContent); } catch (e) {}
    }

    var variantInput = document.getElementById('product-variant-id');
    var priceEl      = document.getElementById('product-price');
    var addBtn       = document.getElementById('product-add-btn');

    // Gallery: all media slides live in the DOM; switching just toggles which
    // one is active (instant swap + CSS crossfade, no network fetch).
    var gallerySlides = document.querySelectorAll('.product-gallery__slide');
    var galleryThumbs = document.querySelectorAll('.product-gallery__thumb');

    function activateMedia(index) {
      if (index < 0 || index >= gallerySlides.length) return;
      gallerySlides.forEach(function(slide, idx) {
        var isActive = idx === index;
        slide.classList.toggle('product-gallery__slide--active', isActive);
        // Pause videos we're leaving; play (muted) the one we're showing.
        var video = slide.querySelector('video');
        if (video) {
          if (isActive) {
            var playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(function() {});
          } else {
            video.pause();
          }
        }
      });
      galleryThumbs.forEach(function(thumb, idx) {
        thumb.classList.toggle('product-gallery__thumb--active', idx === index);
      });
    }

    // Build initial selectedOptions from active pills
    var selectedOptions = [];
    document.querySelectorAll('.product-option__pills').forEach(function(group) {
      var active = group.querySelector('.product-pill--active');
      selectedOptions.push(active ? active.dataset.value : (group.querySelector('.product-pill') || {}).dataset && group.querySelector('.product-pill').dataset.value);
    });

    // Variant pill click
    document.querySelectorAll('.product-pill').forEach(function(pill) {
      pill.addEventListener('click', function() {
        var optIndex = parseInt(this.dataset.option, 10);
        var val = this.dataset.value;
        selectedOptions[optIndex] = val;

        // Update pills UI
        var group = this.closest('.product-option__pills');
        group.querySelectorAll('.product-pill').forEach(function(p) {
          p.classList.toggle('product-pill--active', p.dataset.value === val);
          p.setAttribute('aria-pressed', p.dataset.value === val ? 'true' : 'false');
        });

        // Update selected label
        var label = document.getElementById('option-selected-' + optIndex);
        if (label) label.textContent = val;

        updateVariant();
      });
    });

    function updateVariant() {
      var matched = null;
      for (var i = 0; i < variantsData.length; i++) {
        var v = variantsData[i];
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (v.options[j] !== selectedOptions[j]) { match = false; break; }
        }
        if (match) { matched = v; break; }
      }
      if (!matched) return;

      // Update hidden input
      if (variantInput) variantInput.value = matched.id;

      // Update URL without reload
      var url = new URL(window.location.href);
      url.searchParams.set('variant', matched.id);
      history.replaceState({}, '', url.toString());

      // Update price
      if (priceEl) {
        var html = '';
        if (matched.compare_at_price && matched.compare_at_price > matched.price) {
          html = '<s class="product-price__compare">' + formatMoney(matched.compare_at_price, pageData.moneyFormat) + '</s>' +
                 '<span class="product-price__sale">'  + formatMoney(matched.price, pageData.moneyFormat) + '</span>';
        } else {
          html = '<span class="product-price__regular">' + formatMoney(matched.price, pageData.moneyFormat) + '</span>';
        }
        priceEl.innerHTML = html;
      }

      // Update add-to-cart button
      if (addBtn) {
        if (matched.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.dataset.addText || 'Add to Cart';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.dataset.soldText || 'Sold Out';
        }
      }

      // Show the variant's media if it has one. Prefer matching by media id
      // (works for any media type), then fall back to image position.
      var targetIndex = -1;
      if (matched.featured_media && matched.featured_media.id) {
        for (var s = 0; s < gallerySlides.length; s++) {
          if (String(gallerySlides[s].dataset.mediaId) === String(matched.featured_media.id)) {
            targetIndex = s;
            break;
          }
        }
      }
      if (targetIndex === -1 && matched.featured_image) {
        targetIndex = matched.featured_image.position - 1;
      }
      if (targetIndex !== -1) activateMedia(targetIndex);
    }

    // Money formatter
    function formatMoney(cents, format) {
      if (!format) format = '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      var amountComma = amount.replace(/\d(?=(\d{3})+\.)/g, '$&,');
      var amountInt = Math.floor(cents / 100).toString();
      return format
        .replace('{{amount}}', amountComma)
        .replace('{{amount_no_decimals}}', amountInt)
        .replace('{{amount_with_comma_separator}}', amountComma)
        .replace('{{amount_no_decimals_with_comma_separator}}', amountInt.replace(/\d(?=(\d{3})+$)/g, '$&,'));
    }

    // Quantity stepper
    document.querySelectorAll('.product-qty__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = document.getElementById('product-qty');
        var cur = parseInt(input.value, 10) || 1;
        if (this.dataset.action === 'increase') {
          input.value = cur + 1;
        } else if (this.dataset.action === 'decrease' && cur > 1) {
          input.value = cur - 1;
        }
      });
    });

    // Thumbnail gallery — toggle the matching slide (no image fetch).
    galleryThumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        activateMedia(parseInt(this.dataset.index, 10));
      });
    });

    // Community name — required validation
    var communityNameInput = document.getElementById('community-name-input');
    if (communityNameInput) {
      var communityNameError = document.getElementById('community-name-error');

      form.addEventListener('submit', function(e) {
        if (communityNameInput.value.trim() === '') {
          e.preventDefault();
          communityNameInput.classList.add('product-community-name__input--error');
          if (communityNameError) communityNameError.removeAttribute('hidden');
          communityNameInput.focus();
        }
      });

      communityNameInput.addEventListener('input', function() {
        if (this.value.trim() !== '') {
          this.classList.remove('product-community-name__input--error');
          if (communityNameError) communityNameError.setAttribute('hidden', '');
        }
      });
    }

    // Tab switching
    document.querySelectorAll('.product-tabs__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var tabId = this.dataset.tab;

        document.querySelectorAll('.product-tabs__btn').forEach(function(b) {
          b.classList.remove('product-tabs__btn--active');
          b.setAttribute('aria-selected', 'false');
        });
        document.querySelectorAll('.product-tabs__panel').forEach(function(p) {
          p.classList.remove('product-tabs__panel--active');
        });

        this.classList.add('product-tabs__btn--active');
        this.setAttribute('aria-selected', 'true');
        var panel = document.getElementById('tab-' + tabId);
        if (panel) panel.classList.add('product-tabs__panel--active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
